import { machineMigrationOpportunityPath } from './machineMigrationOpportunityPath';

export const machineMigrationOpportunityOptInPath = (appSlug: string) =>
  `${machineMigrationOpportunityPath(appSlug)}/opt_in`;
